// src/features/weekly-one/WeeklyOneDoneModal.tsx
import { useState, useRef } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import { useWeeklyOne } from '@/features/weekly-one/WeeklyOneContext';

export default function WeeklyOneDoneModal() {
  const { doneModalOpen, closeDoneModal, currentCommitment, markComplete, markMissed } = useWeeklyOne();
  const [saving, setSaving] = useState(false);
  const isSubmitting = useRef(false);

  const handleComplete = async () => {
    if (isSubmitting.current) return;
    isSubmitting.current = true;
    setSaving(true);
    try {
      await markComplete();
      closeDoneModal();
    } catch {
      toast.error('Something went wrong. Please try again.');
    } finally {
      isSubmitting.current = false;
      setSaving(false);
    }
  };

  const handleMissed = async () => {
    if (isSubmitting.current) return;
    isSubmitting.current = true;
    setSaving(true);
    try {
      await markMissed();
      closeDoneModal();
    } catch {
      toast.error('Something went wrong. Please try again.');
    } finally {
      isSubmitting.current = false;
      setSaving(false);
    }
  };

  return (
    <Dialog open={doneModalOpen} onOpenChange={(open) => { if (!open) closeDoneModal(); }}>
      <DialogContent className="sm:max-w-sm">
        <DialogHeader>
          <DialogTitle className="font-serif text-lg">Week complete?</DialogTitle>
        </DialogHeader>

        <div className="pt-1 space-y-4">
          {currentCommitment?.commitment_text && (
            <p className="text-sm text-muted-foreground italic border-l-2 border-border pl-3">
              "{currentCommitment.commitment_text}"
            </p>
          )}

          <p className="text-sm text-foreground">
            Did you follow through on this?
          </p>

          <div className="flex justify-end gap-2 pt-1">
            <Button
              variant="outline"
              size="sm"
              disabled={saving}
              onClick={handleMissed}
            >
              Not this week
            </Button>
            <Button
              size="sm"
              disabled={saving}
              onClick={handleComplete}
              className="text-white font-medium"
              style={{ background: '#1D9E75' }}
            >
              {saving ? 'Saving...' : 'Yes, complete'}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
